module.exports = __webpack_public_path__ + "static/media/F1M3_CNY_2022_Tiger_Floating_Icon_v4.327baf24.gif";